import { cloudApi } from '../api/index';
import {
  ONE_DAY,
  formatTime,
  ROOM_TYPE,
  statTxt,
  _setDefaultMapImg,
  isWarnDay,
} from '../base/CONST';
const { getCloudDetails, getCloudBaseData, getCloudAdData, exportCloudData } =
  cloudApi;

export default {
  data() {
    return {
      currServ: null,
      bDPageCount: 0,
      adData: [],
      baseData: [],
      formInline: {
        date: [new Date() - ONE_DAY * 7, new Date()],
      },
      adFormInline: {
        date: [new Date() - ONE_DAY * 7, new Date()],
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dataPanelList: [
        {
          title: '本月广告展示',
          value: 0,
          total: 0,
          unit: '万',
        },
        {
          title: '付费人数',
          value: 0,
          total: 0,
          unit: '',
        },
        {
          title: '游戏时长（分）',
          value: 0,
          total: 0,
          unit: '',
        },
        {
          title: '游戏人数',
          value: 0,
          total: 0,
          unit: '',
        },
        // {
        //   title: '游戏次数',
        //   value: 500,
        //   total: 1188,
        //   unit: ''
        // },
      ],
      getDate: [],
      adPagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      basePagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
    };
  },
  filters: {
    setDefaultMapImg(url) {
      return _setDefaultMapImg(url);
    },
    formatTime(time) {
      return formatTime(time);
    },
    formatMoney(money) {
      money = +money;
      if (money >= 10000) {
        return (money / 10000).toFixed(2);
      }
      return money;
    },
    getRoomType(type) {
      return ROOM_TYPE[type];
    },
    getState(state) {
      return statTxt[state];
    },
    remainderTime(expiredTime) {
      if (('' + expiredTime).length < 13) expiredTime *= 1000;
      const _remainderTime = expiredTime - Date.now();
      let remainderDay = Math.round(_remainderTime / ONE_DAY);
      remainderDay = remainderDay <= 0 ? 0 : remainderDay;
      return `剩余${remainderDay}天`;
    },
  },
  created() {
    this.currServ = JSON.parse(this.$route.params.currServ);
    console.log('data.vue created---', this.currServ);
    if (this.currServ) {
      getCloudDetails({ id: this.currServ.id }).then(res => {
        if (res.code === 0) {
          const {
            month_ad_count,
            month_pay_count,
            month_player_count,
            month_time,
            total_ad_count,
            total_pay_count,
            total_player_count,
            total_time,
          } = res.data;
          this.dataPanelList = [
            {
              title: '本月广告展示',
              value: month_ad_count,
              total: total_ad_count,
              unit: '万',
            },
            {
              title: '付费人数',
              value: month_pay_count,
              total: total_pay_count,
              unit: '万',
            },
            {
              title: '游戏时长(分)',
              value: Math.floor(month_time / 60),
              total: Math.floor(total_time / 60),
              unit: '万',
            },
            {
              title: '游戏人数',
              value: month_player_count,
              total: total_player_count,
              unit: '万',
            },
          ];
        }
      });
      this.getBaseData();
      this.getAdData();
    }
  },
  methods: {
    isWarnDay(time) {
      return isWarnDay(time);
    },
    getAdData() {
      getCloudAdData({
        id: this.currServ.id,
        start_time: Math.floor(this.adFormInline.date[0] / 1000),
        end_time: Math.floor((+this.adFormInline.date[1] + ONE_DAY) / 1000 - 1),
        page: this.adPagination.page,
        page_size: this.adPagination.page_size,
      }).then(res => {
        console.log('getCloudAdData---', res);
        if (res.code === 0) {
          this.adData = res.data.list || [];
          this.adPagination.total = parseInt(res.data.total_count, 10) || 0;
          // this.adPagination.page++
        }
      });
    },
    getBaseData() {
      getCloudBaseData({
        id: this.currServ.id,
        start_time: Math.floor(this.formInline.date[0] / 1000),
        end_time: Math.floor((+this.formInline.date[1] + ONE_DAY) / 1000 - 1),
        page: this.basePagination.page,
        page_size: this.basePagination.page_size,
      }).then(res => {
        if (res.code === 0) {
          this.baseData = (res.data.list || []).map(val => {
            val.avg_time = Math.floor(val.avg_time / 60).toFixed(2);
            val.total_time = Math.floor(val.total_time / 60).toFixed(2);
            return val;
          });
          this.basePagination.total = parseInt(res.data.total_count, 10) || 0;
          // this.basePagination.page++
        }
      });
    },
    bDPaginationChange(page) {
      this.basePagination.page = page;
      this.getBaseData();
    },
    aDPaginationChange(page) {
      this.adPagination.page = page;
      this.getAdData();
    },
    exportFn(formInline) {
      exportCloudData({
        id: this.currServ.id,
        start_time: Math.floor(this[formInline].date[0] / 1000),
        end_time: Math.floor((+this[formInline].date[1] + ONE_DAY) / 1000 - 1),
      }).then(res => {
        if (res.code === 0) {
          location.href = res.data.url; // TODO
        }
      });
    },
    changeDate(val) {
      if (val != null) {
        if ((val[1] - val[0] + 1) / 86400000 > 365) {
          this.$message.error('最多选择一年，请重新选择查询时间');
        }
      }
    },
    queryAdTableFn() {
      this.$refs.adForm.validateField('date', errMsg => {
        if (!errMsg) {
          const days = Math.round(
            (this.adFormInline.date[1] - this.adFormInline.date[0]) / ONE_DAY,
          );
          if (days > 365) {
            this.$message.error('最多选择一年，请重新选择查询时间');
            return;
          }
          this.getAdData();
        }
      });
    },
    queryBaseTableFn() {
      this.$refs.baseForm.validateField('date', errMsg => {
        if (!errMsg) {
          const days = Math.round(
            (this.formInline.date[1] - this.formInline.date[0]) / ONE_DAY,
          );
          if (days > 365) {
            this.$message.error('最多选择一年，请重新选择查询时间');
            return;
          }
          this.getBaseData();
        }
      });
    },
  },
};
